
import { useState } from "react";
import { Link, FileText } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UrlInput } from "./recipe-input/UrlInput";
import { TextInput } from "./recipe-input/TextInput";

interface RecipeInputProps {
  onSubmit: (input: string, type: "url" | "text") => void;
  isLoading: boolean;
}

export const RecipeInput = ({ onSubmit, isLoading }: RecipeInputProps) => {
  const [url, setUrl] = useState("");
  const [text, setText] = useState("");

  const handleSubmit = (input: string, type: "url" | "text") => {
    // Call the parent's onSubmit with the input
    onSubmit(input, type);
  };

  return (
    <div className="w-full">
      <Tabs defaultValue="url" className="w-full">
        <TabsList className="grid w-full grid-cols-2 mb-4">
          <TabsTrigger value="url" className="flex items-center gap-2">
            <Link className="w-4 h-4" />
            <span>URL</span>
          </TabsTrigger>
          <TabsTrigger value="text" className="flex items-center gap-2">
            <FileText className="w-4 h-4" />
            <span>Direct Text</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="url">
          <UrlInput 
            url={url}
            setUrl={setUrl}
            onSubmit={handleSubmit}
            isLoading={isLoading}
          />
        </TabsContent>

        <TabsContent value="text">
          <TextInput
            text={text}
            setText={setText}
            onSubmit={handleSubmit}
            isLoading={isLoading}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};
